<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-sushi">
      <div class="px-3 col-3 p-0">
        <div class="heading-sushi">{{ $t('result.round') }}</div>
        <div class="text-subhead-sushi">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-sushi">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead-sushi">{{ data.bet | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-sushi">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead-sushi">{{ data.winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-sushi">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead-sushi">{{ data.balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-sushi pt-3">
      <div class="text-game-sushi">{{ 'Zushi prime' }}</div>
      <div class="text-subgame-sushi">{{ $t('sushi.name') }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div v-if="data.freeSpin" class="col-1 d-flex align-items-center justify-content-center">
          <i class="fas fa-caret-left arrow-side-sushi" @click="delCount()"></i>
        </div>
        <div class="all-table-sushi container d-flex flex-column justify-content-center">
          <table>
            <tbody>
              <tr v-for="(row, index) in table" :key="index">
                <td v-for="(col, i) in row" :key="`${index}${i}`">
                  <img class="icon-symbol" :src="require(`../../assets/resultGame/sushi/symbol_${col}.png`)" alt="">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="data.freeSpin" class="col-1 d-flex align-items-center justify-content-center">
          <i class="fas fa-caret-right arrow-side-sushi" @click="addCount()"></i>
        </div>
      </div>
      <div v-if="data.freeSpin" class="text-subgame-sushi mb-1">{{ $t('result.freespin') + ' ' +
        data.detail.freeSpinsPlayed + '/' + data.detail.freeSpinsCount}}</div>
      <div v-if="data.freeSpin" class="text-game-sushi">{{ $t('result.multiplier') + ' ' + 'x' +
        data.detail.freeSpinsCurrentMultiplier}}</div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>
      <div v-if="data.detail.featureBuy" class="text-feature-sushi" style="font-">Feature Buy</div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="bet-box-sushi p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in data.detail.winCombos" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-sushi item">
                <div class="d-flex justify-content-start bet-wrapper-sushi item">
                  <img class="icon-detail-sushi" :src="require(`../../assets/resultGame/sushi/symbol_${detail[0]}.png`)"
                    alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1 green">{{ `${detail[1]} ` + $t('result.kind') }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ (data.freeSpin
                      ? (data.detail.freeSpinsCurrentMultiplier === 0
                        ? (data.detail.winnings[index] * 1)
                        : (data.detail.winnings[index] * data.detail.freeSpinsCurrentMultiplier))
                      : (data.detail.winnings[index])
                    ) | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bet-warpper item" v-if="data.detail.winShowsCount === 0">
            <div class="d-flex justify-content-between mt-5">
              <div class="bet-wrapper-sushi item align-content-center d-flex">
                <div class="d-flex justify-content-center bet-wrapper-sushi item align-content-center p-3">
                  <p class="my-1 red">{{ 'No Winnings' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-crazyworm',
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 4, 7, 10, 13,],
        [2, 5, 8, 11, 14,],
        [3, 6, 9, 12, 15,],
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      result: this.data,
      count: this.data.count,
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
    }
  },
  async created() {
    await this.mapSymbol()
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header')[0].offsetHeight
    },
    mapSymbol() {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      if (this.data.freeSpin && this.data.detail.freeSpinsPlayed > 0) {
        const reel1 = this.data.game.config.freeGameReel1
        const reel2 = this.data.game.config.freeGameReel2
        const reel3 = this.data.game.config.freeGameReel3
        const reel4 = this.data.game.config.freeGameReel4
        const reel5 = this.data.game.config.freeGameReel5

        const indexReel1 = this.data.detail.freeReelStopIndexes[0]
        const indexReel2 = this.data.detail.freeReelStopIndexes[1]
        const indexReel3 = this.data.detail.freeReelStopIndexes[2]
        const indexReel4 = this.data.detail.freeReelStopIndexes[3]
        const indexReel5 = this.data.detail.freeReelStopIndexes[4]

        this.table[0][0] = reel1[indexReel1]
        this.table[1][0] = reel1[indexReel1 + 1] === undefined ? reel1[0] : reel1[indexReel1 + 1]
        this.table[2][0] = reel1[indexReel1 + 2] === undefined ? indexReel1 + 2 === reel1.length ? reel1[0] : reel1[1] : reel1[indexReel1 + 2]
        this.table[0][1] = reel2[indexReel2]
        this.table[1][1] = reel2[indexReel2 + 1] === undefined ? reel2[0] : reel2[indexReel2 + 1]
        this.table[2][1] = reel2[indexReel2 + 2] === undefined ? indexReel2 + 2 === reel2.length ? reel2[0] : reel1[1] : reel2[indexReel2 + 2]
        this.table[0][2] = reel3[indexReel3]
        this.table[1][2] = reel3[indexReel3 + 1] === undefined ? reel3[0] : reel3[indexReel3 + 1]
        this.table[2][2] = reel3[indexReel3 + 2] === undefined ? indexReel3 + 2 === reel3.length ? reel3[0] : reel3[1] : reel3[indexReel3 + 2]
        this.table[0][3] = reel4[indexReel4]
        this.table[1][3] = reel4[indexReel4 + 1] === undefined ? reel4[0] : reel4[indexReel4 + 1]
        this.table[2][3] = reel4[indexReel4 + 2] === undefined ? indexReel4 + 2 === reel4.length ? reel4[0] : reel4[1] : reel4[indexReel4 + 2]
        this.table[0][4] = reel5[indexReel5]
        this.table[1][4] = reel5[indexReel5 + 1] === undefined ? reel5[0] : reel5[indexReel5 + 1]
        this.table[2][4] = reel5[indexReel5 + 2] === undefined ? indexReel5 + 2 === reel5.length ? reel5[0] : reel5[1] : reel5[indexReel5 + 2]
      } else {
        const reel1 = this.data.game.config.baseGameReel1
        const reel2 = this.data.game.config.baseGameReel2
        const reel3 = this.data.game.config.baseGameReel3
        const reel4 = this.data.game.config.baseGameReel4
        const reel5 = this.data.game.config.baseGameReel5

        const indexReel1 = this.data.detail.baseReelStopIndexes[0]
        const indexReel2 = this.data.detail.baseReelStopIndexes[1]
        const indexReel3 = this.data.detail.baseReelStopIndexes[2]
        const indexReel4 = this.data.detail.baseReelStopIndexes[3]
        const indexReel5 = this.data.detail.baseReelStopIndexes[4]

        this.table[0][0] = reel1[indexReel1]
        this.table[1][0] = reel1[indexReel1 + 1] === undefined ? reel1[0] : reel1[indexReel1 + 1]
        this.table[2][0] = reel1[indexReel1 + 2] === undefined ? indexReel1 + 2 === reel1.length ? reel1[0] : reel1[1] : reel1[indexReel1 + 2]
        this.table[0][1] = reel2[indexReel2]
        this.table[1][1] = reel2[indexReel2 + 1] === undefined ? reel2[0] : reel2[indexReel2 + 1]
        this.table[2][1] = reel2[indexReel2 + 2] === undefined ? indexReel2 + 2 === reel2.length ? reel2[0] : reel1[1] : reel2[indexReel2 + 2]
        this.table[0][2] = reel3[indexReel3]
        this.table[1][2] = reel3[indexReel3 + 1] === undefined ? reel3[0] : reel3[indexReel3 + 1]
        this.table[2][2] = reel3[indexReel3 + 2] === undefined ? indexReel3 + 2 === reel3.length ? reel3[0] : reel3[1] : reel3[indexReel3 + 2]
        this.table[0][3] = reel4[indexReel4]
        this.table[1][3] = reel4[indexReel4 + 1] === undefined ? reel4[0] : reel4[indexReel4 + 1]
        this.table[2][3] = reel4[indexReel4 + 2] === undefined ? indexReel4 + 2 === reel4.length ? reel4[0] : reel4[1] : reel4[indexReel4 + 2]
        this.table[0][4] = reel5[indexReel5]
        this.table[1][4] = reel5[indexReel5 + 1] === undefined ? reel5[0] : reel5[indexReel5 + 1]
        this.table[2][4] = reel5[indexReel5 + 2] === undefined ? indexReel5 + 2 === reel5.length ? reel5[0] : reel5[1] : reel5[indexReel5 + 2]
      }

      if (this.data.detail.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      const countData = this.data.count + 1
      this.$emit('fetchResult', countData)
      await this.mapSymbol()
    },
    async delCount() {
      const countData = this.data.count - 1
      this.$emit('fetchResult', countData)
      await this.mapSymbol()
    },
  }
}
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #461E00
    /* margin: 0; */
}

.icon-detail-sushi {
  width: 90px;
  height: 100px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-sushi {
  color: #cac095;
  text-align: center;
  font-size: 90px;
}

.bet-box-sushi {
  background: #FFCE1A;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-sushi .item {
  color: #000000;
  background: #FFCE1A;
  line-height: 1;
  border-radius: 10px;
  border: 2px solid #000000;
}

.bet-box-sushi .bet-wrapper-sushi:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-sushi,
.result-wrapper {
  font-size: 35px;
}

.header-sushi {
  background: #FFCE1A;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-sushi>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-sushi {
  color: #000000;
  text-align: center;
}

.content-result-sushi {
  background: #444444;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-sushi {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-game-sushi {
  color: #ffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-sushi {
  font-size: px;
  color: #000000;
  text-align: center;
}

.text-subgame-sushi {
  font-size: 20px;
  color: #FB820B;
  text-align: center;
}

.text-feature-sushi {
  font-size: 30px;
  color: #ffffff;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #F9C772;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #F9C772;
  text-align: center;
}

.icon-symbol {
  width: 100%;
}

.bet-box-sushi {
  min-width: 600px;
  max-width: auto;
}

.all-table-sushi {
  background: url('~@/assets/resultGame/sushi/sushi_frame.png') no-repeat;
  background-size: 780px 450px;
  width: 640px;
  height: 450px;
  border-radius: 5px;
  font-size: 30px;
  margin-top: 1%;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .all-table-sushi {
    background-size: 600px 380px;
    width: 500px;
    height: 380px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-sushi {
    font-size: 60px;
  }

  .bet-box-sushi {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-sushi,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-sushi,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading-sushi {
    font-size: 18px;
  }

  .all-table-sushi {
    background-size: 500px 380px;
    width: 500px;
    height: 350;
    margin-bottom: 1%;
    margin-top: 1%;
    padding-top: 3%;
    padding-bottom: 35px;
  }

  .text-subhead-sushi {
    font-size: 18px;
  }

  .arrow-side-sushi {
    font-size: 50px;
  }

  .bet-box-sushi {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header-sushi>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-sushi {
    font-size: 12px;
  }

  .all-table-sushi {
    background-size: 260px 180px;
    width: 260px;
    height: 180px;
    padding-top: 1.9rem;
  }

  .text-subhead-sushi {
    font-size: 14px;
  }

  .bet-box-sushi {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bet-wrapper-sushi,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-sushi {
    width: 50px;
    height: 60px;
  }
}
</style>